import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  CssBaseline,
  IconButton,
  Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './component/layout/Sidebar';
import routes from './routes';
import { SnackbarProvider } from './component/providers/SnackbarProvider';
import DialogProvider from './context/dialog/DialogProvider';
import LogoutIcon from '@mui/icons-material/Logout';

const AppLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const isAuthenticated = !!sessionStorage.getItem('token');
  const email = sessionStorage.getItem('email');
  const navigate = useNavigate();

  const handleClick = () => {

    navigate('/logout');
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar ve Sidebar sadece login sayfası dışında ve giriş yapılmışsa gösterilsin */}
      {!isLoginPage && isAuthenticated && (
        <>
          <AppBar
            position="fixed"
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: '#04477E'
            }}
          >
            <Toolbar sx={{ minHeight: { xs: 48, sm: 56, md: 64 } }}>
              <IconButton
                color="inherit"
                edge="start"
                sx={{ mr: 2 }}
                onClick={toggleDrawer}
              >
                <MenuIcon />
              </IconButton>

              <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                Onsa Admin Panel
              </Typography>

              {/* E-posta gösterimi */}
              <Typography variant="body1" sx={{ color: '#fff', mr: 2, display: { xs: 'none', sm: 'none', md: 'block' } }}>
                {email}
              </Typography>

              <Button
                variant="outlined"
                color="inherit"
                startIcon={<LogoutIcon />}
                size="small"
                sx={{
                  textTransform: 'none',
                  borderColor: '#ffffffaa',
                  color: '#fff',
                  px: { xs: 1, md: 2 },
                  minWidth: 'auto',
                  '&:hover': {
                    backgroundColor: '#ffffff22',
                    borderColor: '#ffffff',
                  },
                }}
                onClick={handleClick}
              >
                <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                  Çıkış Yap
                </Box>
              </Button>
            </Toolbar>
          </AppBar>
          <Sidebar open={drawerOpen} />
        </>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0
        }}
      >
        {/* AppBar'ın yüksekliği kadar boşluk bırak */}
        {!isLoginPage && isAuthenticated && <Toolbar sx={{ minHeight: { xs: 48, sm: 56, md: 64 } }} />}

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            width: '100%',
            minWidth: 0
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: 'none',
              overflowX: 'hidden',
              paddingBottom: 2,
              minWidth: 0
            }}
          >
            <Routes>
              {routes.map((route, index) => {
                if (!route.component) {
                  console.warn("Route missing component:", route);
                  return null;
                }

                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={<route.component />}
                  />
                );
              })}
            </Routes>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

function App() {
  return (
    <Router>
      <SnackbarProvider>
        <DialogProvider>
          <AppLayout />
        </DialogProvider>
      </SnackbarProvider>
    </Router>
  );
}

export default App;
